import styled, { css } from 'styled-components';
import { key, palette } from 'styled-theme';

import { media } from '../../../helper/styleHelper';
import Label from '../label';

export const StyledTabButtonContainer = styled.div`
  border-radius: ${key('sizes.borderRadius.tiny', '20px')};
  opacity: 1;
  cursor: pointer;
  text-transform: capitalize;
  color: ${palette('primary', 0)};
  position: relative;

  display: grid;
  grid-auto-flow: column;
  gap: 0;
`;

export const StyledTabButton = styled.button`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: ${key('sizes.gutter.tiny', '10px')};
  opacity: 1;
  padding: ${key('sizes.gutter.8', '8px')} ${key('sizes.gutter.smaller', '20px')};
  text-transform: ${(props) => (props?.textTransform ? props?.textTransform : 'none')};
  cursor: pointer;

  ${media.xl`
          padding: ${key('sizes.gutter.5', '5px')} ${key('sizes.gutter.smaller', '20px')};
        `};

  ${media.xlr`
          padding: ${key('sizes.gutter.6', '6px')} ${key('sizes.gutter.smaller', '20px')};
        `};

  ${media.xxl`
          padding: ${key('sizes.gutter.8', '8px')} ${key('sizes.gutter.smaller', '20px')};
        `};

  ${(props) =>
    props?.isFirst && props?.isLast
      ? css`
          border: 1px solid ${palette('border', 0)};
          border-radius: ${key('sizes.borderRadius.tiny', '10px')};
        `
      : props?.isFirst
      ? css`
          border-radius: ${key('sizes.borderRadius.tiny', '10px')} 0 0
            ${key('sizes.borderRadius.tiny', '5px')};
          border: 1px solid ${palette('border', 0)};
          border-width: 1px 0px 1px 1px;
        `
      : props?.isLast
      ? css`
          border-radius: 0 ${key('sizes.borderRadius.tiny', '10px')}
            ${key('sizes.borderRadius.tiny', '5px')} 0;
          border: 1px solid ${palette('border', 0)};
          border-width: 1px 1px 1px 1px;
        `
      : props?.isMiddle
      ? css`
          border: 1px solid ${palette('border', 0)};
          border-width: 1px 0px 1px 1px;
        `
      : css``}

  ${(props) =>
    props?.isActive
      ? css`
          color: ${palette('text', 0)};
          background: ${palette('background', 2)} 0% 0% no-repeat padding-box;
        `
      : css`
          color: ${palette('white', 0)};
          background: ${palette('background', 0)} 0% 0% no-repeat padding-box;
        `}
`;

export const Title = styled(Label)`
  ${(props) =>
    props?.isActive
      ? css`
          color: ${palette('text', 0)};
        `
      : css`
          color: ${palette('white', 0)};
        `}
`;
